import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        formHeaderRoot: {
            marginTop: 12,
            backgroundColor: '#fff',
            border: '1px solid #dadce0',
            borderBottom: '1px solid #E0E0E0',
            borderRadius: 0,
            padding: 24,
            paddingTop: 22,
            position: 'relative',
        },
        themeStripe: {
            paddingLeft: 0,
            paddingRight: 0,
            backgroundColor: '#2F80ED',
            color: 'rgba(0, 0, 0, 1)',
            height: 6,
            left: -1,
            position: 'absolute',
            top: -1,
            width: 'calc(100% + 2px)',
        },
        firmHeaderContainer: {
            display: 'flex',
            width: '100%',
            '& img': {
                borderRadius: '50%',
            },
        },
        firmName: {
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '23px',
            lineHeight: '27px',
            color: '#000000',
        },
        formHeaderContent: {
            display: 'flex',
            flexDirection: 'column',
            marginLeft: theme.spacing(3),
        },
        firmDescription: {
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontSize: '14px',
            lineHeight: '16px',
            color: '#333333',
        },
    }),
);
